import { useEffect, useRef } from "react";

const PETAL_COLORS = ["#CF8696", "#D8B0B8", "#F0E2E4", "#A2B6D0", "#B0A3A0"];

export const PetalsCanvas = ({ className = "" }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
            return;
        const canvas = ref.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        let raf = 0;
        let w = 0;
        let h = 0;
        let petals = [];
        let visible = true;

        const spawn = (init = false) => ({
            x: Math.random() * w,
            y: init ? Math.random() * h : -24,
            r: 3.5 + Math.random() * 5.5,
            vy: 0.35 + Math.random() * 0.75,
            sway: 0.5 + Math.random() * 1.3,
            phase: Math.random() * Math.PI * 2,
            rot: Math.random() * Math.PI * 2,
            vr: (Math.random() - 0.5) * 0.02,
            alpha: 0.35 + Math.random() * 0.4,
            color:
                PETAL_COLORS[Math.floor(Math.random() * PETAL_COLORS.length)],
        });

        const resize = () => {
            const dpr = Math.min(window.devicePixelRatio || 1, 2);
            w = canvas.offsetWidth;
            h = canvas.offsetHeight;
            canvas.width = w * dpr;
            canvas.height = h * dpr;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };

        const draw = () => {
            if (!visible) return;
            ctx.clearRect(0, 0, w, h);
            petals.forEach((p, i) => {
                p.phase += 0.01;
                p.y += p.vy;
                p.x += Math.sin(p.phase * 2.2) * p.sway * 0.45;
                p.rot += p.vr;
                if (p.y > h + 24) petals[i] = spawn();
                ctx.save();
                ctx.translate(p.x, p.y);
                ctx.rotate(p.rot);
                ctx.globalAlpha = p.alpha;
                ctx.fillStyle = p.color;
                ctx.beginPath();
                ctx.ellipse(0, 0, p.r, p.r * 0.6, 0, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            });
            raf = requestAnimationFrame(draw);
        };

        const io = new IntersectionObserver(([entry]) => {
            visible = entry.isIntersecting;
            if (visible) {
                cancelAnimationFrame(raf);
                raf = requestAnimationFrame(draw);
            }
        });

        resize();
        petals = Array.from(
            { length: Math.min(18, Math.max(8, Math.floor(w / 90))) },
            () => spawn(true),
        );
        draw();
        io.observe(canvas);
        window.addEventListener("resize", resize);
        return () => {
            cancelAnimationFrame(raf);
            io.disconnect();
            window.removeEventListener("resize", resize);
        };
    }, []);

    return <canvas ref={ref} className={className} aria-hidden="true" />;
};

export default PetalsCanvas;
